/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import WebpageEditContext from "components/webpage-selector/context";
import { AddNewsItemButton } from "./add-news-item-button";
import { WebpageSelectorDisplay } from "components/webpage-selector/display";
import { NewsItemSelectDialog } from "./news-item-select-dialog";
import { WebpageDeleteDialog } from "components/webpage-selector/dialog-delete";

const NewsItemSelectorWrapper = (props) => {
    
    const {
        index: idx,
        model,
        selectedData,
        AddComponent,
        DisplayComponent,
        filter,
        filterValue,
        webpage,
        setWebpage,
        webpageGuid,
        setWebpageGuid,
        onSelectWebpage: onSelectWebpageHandler,
        onWebpageRemoved,
        changeTitle,
        changeDescription,
        defaultTitleDescription,
        defaultImage,
        loadingWebpage,
        setLoadingWebpage,
    } = props;
    
    const [webpages, setWebpages] = useState();
    const [original, setOriginal] = useState();
    const [selectedWebpage, setSelectedWebpage] = useState(webpage);
    const [open, setOpen] = React.useState(false);
    const [openRemove, setOpenRemove] = React.useState(false);
    const [hasWebpage, setHasWebpage] = useState();
    const [localState, setLocalState] = useState({
        webpage: { title: "", description: "" },
    });

    const onChange = async () => {
        setOpen(true);
    };
    const onRemove = async () => {
        setOpenRemove(true);
    };
    const onSelectWebpage = (selectWebpage) => {
        setSelectedWebpage(selectWebpage);
        onSelectWebpageHandler(selectWebpage);
        handleClose();
    };
    const handleClose = () => {
        setSelectedWebpage(original);
        setOpen(false);
    };
    const ctx = {
        open,
        setOpen,
        handleClose,
        selectedData,
        webpage,
        hasWebpage,
        onChange,
        onRemove,
        selectedWebpage,
        setSelectedWebpage,
        openRemove,
        setOpenRemove,
        onSelectWebpage,
        onWebpageRemoved,
        model,
        webpages,
        setWebpages,
        defaultImage,
        defaultTitleDescription,
        changeTitle,
        changeDescription,
        localState,
        setLocalState,
    };

    useEffect(() => {
        if (webpage) {
            setOriginal(webpage);
            setSelectedWebpage(webpage);
            setHasWebpage(true);
        }
    }, [webpage]);

    useEffect(() => {
        if (selectedWebpage) {
            setHasWebpage(true);
        }
    }, [selectedWebpage]);

    return (
        <Fragment>
            <WebpageEditContext.Provider value={ctx}>
                
                <WebpageSelectorDisplay
                    idx={idx}
                    AddComponent={AddComponent || AddNewsItemButton}
                    DisplayComponent={DisplayComponent}
                />
                
                <NewsItemSelectDialog
                    filter={filter}
                    filterValue={filterValue}
                    onAddToFeaturedPages={props.onAddToFeaturedPages}
                />
                
                <WebpageDeleteDialog
                    deleteType='REMOVE'
                />
                
            </WebpageEditContext.Provider>
        </Fragment>
    );
};

export { NewsItemSelectorWrapper };

